import { useState } from "react";
import { toast } from "sonner";
import { Card } from "../panel/PanelShell";
import { Field, inputCls } from "../forms/Fields";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { fmtDate } from "../../lib/format";

export default function ProfileTab() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: user.name || "", phone: user.phone || "", city: user.city || "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/auth/profile", form);
      setUser(data);
      toast.success("Profile updated");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="max-w-2xl">
      <div className="mb-8 flex items-center gap-4">
        {user.picture ? <img src={user.picture} alt="" className="h-16 w-16 rounded-full object-cover" /> :
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-navy text-xl font-bold text-gold">{user.name?.[0]}</div>}
        <div><p className="text-lg font-bold text-navy">{user.name}</p><p className="text-sm text-slate-500">{user.email} · Member since {fmtDate(user.created_at)}</p></div>
      </div>
      <form onSubmit={save} className="grid gap-5 sm:grid-cols-2" data-testid="profile-form">
        <Field label="Full name" id="p-name"><input id="p-name" required minLength={2} className={inputCls} value={form.name} onChange={set("name")} data-testid="profile-name-input" /></Field>
        <Field label="Mobile" id="p-phone"><input id="p-phone" className={inputCls} value={form.phone} onChange={set("phone")} data-testid="profile-phone-input" /></Field>
        <Field label="City" id="p-city"><input id="p-city" className={inputCls} value={form.city} onChange={set("city")} data-testid="profile-city-input" /></Field>
        <Field label="Email" id="p-email"><input id="p-email" disabled className={`${inputCls} bg-slate-50 text-slate-500`} value={user.email} /></Field>
        <button disabled={saving} data-testid="profile-save-btn" className="w-fit rounded-full bg-navy px-6 py-3 text-sm font-semibold text-white hover:bg-navy-700 disabled:opacity-60">Save changes</button>
      </form>
    </Card>
  );
}
